import { useMemo } from 'react';

import { CustomAsyncSelectOption } from 'modules/_shared/components/CustomAsyncSelect/types/CustomAsyncSelectOption';
import { TradingOfferType } from 'types/TradingOffer';

type UseGetMaxSharesToTransfer = {
  partnerActualSharesCount: number;
  selectedHoldingClassOption: CustomAsyncSelectOption | null;
  tradingOfferType: TradingOfferType;
};

export const useGetMaxSharesToTransfer = ({
  partnerActualSharesCount,
  selectedHoldingClassOption,
  tradingOfferType,
}: UseGetMaxSharesToTransfer) => {
  const maxSharesToTransfer = useMemo(() => {
    if (tradingOfferType === 'BUY') {
      return Infinity;
    }

    if (!selectedHoldingClassOption) return partnerActualSharesCount;

    const holdingClassSharesCount =
      (selectedHoldingClassOption?.sharesCount as number) || 0;

    return Math.min(partnerActualSharesCount, holdingClassSharesCount);
  }, [partnerActualSharesCount, selectedHoldingClassOption, tradingOfferType]);

  return {
    data: { maxSharesToTransfer },
  };
};
